import { ApiScenarioEntityType, scenarioApi } from '../apis';
import { Action, Dispatch } from 'redux';
import { fetchReasonsSuccess, fetchReasonsV2Success } from './scenarioReducer';

/*
 * @deprecated Use fetchReasonsV2 in the future.
 */
export const fetchReasons =
  (entityType?: ApiScenarioEntityType) =>
  async (dispatch: Dispatch): Promise<Action> => {
    const reasons = await scenarioApi.findAllScenarioReasons({ entityType });
    return dispatch(fetchReasonsSuccess(reasons));
  };

export const fetchReasonsV2 =
  (entityType: ApiScenarioEntityType) =>
  async (dispatch: Dispatch): Promise<Action> => {
    const reasons = await scenarioApi.findAllScenarioReasonsV2({ entityType });
    return dispatch(fetchReasonsV2Success(reasons));
  };
